import { Panel } from './Panel';
import { RadioButton } from '../ui';
import { LoadContext, SoundEffect } from "../../../utils";
import { Settings } from "../../../settings";
import { Sprite } from 'pixi.js';
import { Focusable, InteractiveWrapper } from "../../../ui";
import { Game } from '../../../game';
import { PING_SFX } from '../../../constants';

export class SFXType extends Panel
{
    private oneButton:RadioButton;
    private twoButton:RadioButton;
    private threeButton:RadioButton;
    private allSfx: {[opt:string]: SoundEffect};

    public static preload() {
        const loader = LoadContext.current;
        loader.add('Settings', './assets/accessibility/Settings{size}.json');
        for (const opt in PING_SFX)
        {
            loader.add(opt, `./assets/sfx/${PING_SFX[opt]}`);
        }
    }

    constructor( game:Game )
    {
        super(
            game,
            "Sound Effect Type",
            {
                title: "CYB_Panel2_SoundEffectType",
                explain: 'CYB_Panel2_SFX_Explanation',
                settings: 'CYB_Panel2_SFX_Settings',
            },
            {width: 650, height: 253}
        );

        const loader = LoadContext.current;
        this.allSfx = {};
        for (const opt in PING_SFX)
        {
            const sfx = new SoundEffect(loader.getAsset(opt), game);
            this.allSfx[opt] = sfx;
        }

        const icon:Sprite = new Sprite( loader.getSpritesheet('Settings').textures['icon_soundefftype'] );
        icon.position.set( this.icon_x, this.icon_y );
        this.addChild( icon );


        this.oneButton = new RadioButton( "Option 1", {fontName: 'AsapMedium', fontSize: 30 } );
        this.oneButton.position.set( 110, 130 );
        this.disposables.add(new InteractiveWrapper(this.oneButton, {
            onHover: () => {
                this.game.vo.playHighlight(this.oneButton.active ? 'CYB_Panel2_SoundEffect1On' : 'CYB_Panel2_SoundEffect1Off');
            },
            onFocus: async () => {
                await this.game.vo.playHighlight(this.oneButton.active ? 'CYB_Panel2_SoundEffect1On' : 'CYB_Panel2_SoundEffect1Off');
                await this.game.vo.playHighlight('CYB_Panel_SettingEdit');
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setSfxType(Settings.SfxStyle.SFX_1);
                this.game.logEvent("change_setting", "sfx_type_1");
                await this.allSfx[Settings.SfxStyle.SFX_1].play();
                await this.game.vo.playVO('CYB_Panel2_SoundEffect1On');
            }
        }));
        this.addChild( this.oneButton );


        this.twoButton = new RadioButton( "Option 2", {fontName: 'AsapMedium', fontSize: 30 } );
        this.twoButton.position.set( 110, 200 );
        this.disposables.add(new InteractiveWrapper(this.twoButton, {
            onHover: () => {
                this.game.vo.playHighlight(this.twoButton.active ? 'CYB_Panel2_SoundEffect2On' : 'CYB_Panel2_SoundEffect2Off');
            },
            onFocus: async () => {
                await this.game.vo.playHighlight(this.twoButton.active ? 'CYB_Panel2_SoundEffect2On' : 'CYB_Panel2_SoundEffect2Off');
                await this.game.vo.playHighlight('CYB_Panel_SettingEdit');
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setSfxType(Settings.SfxStyle.SFX_2);
                this.game.logEvent("change_setting", "sfx_type_2");
                await this.allSfx[Settings.SfxStyle.SFX_2].play();
                await this.game.vo.playVO('CYB_Panel2_SoundEffect2On');
            }
        }));
        this.addChild( this.twoButton );


        this.threeButton = new RadioButton( "Option 3", {fontName: 'AsapMedium', fontSize: 30 } );
        this.threeButton.position.set( 380, 130 );
        this.disposables.add(new InteractiveWrapper(this.threeButton, {
            onHover: () => {
                this.game.vo.playHighlight(this.threeButton.active ? 'CYB_Panel2_SoundEffect3On' : 'CYB_Panel2_SoundEffect3Off');
            },
            onFocus: async () => {
                await this.game.vo.playHighlight(this.threeButton.active ? 'CYB_Panel2_SoundEffect3On' : 'CYB_Panel2_SoundEffect3Off');
                await this.game.vo.playHighlight('CYB_Panel_SettingEdit');
            },
            onTap: async () => {
                this.game.vo.stop();
                this.setSfxType(Settings.SfxStyle.SFX_3);
                this.game.logEvent("change_setting", "sfx_type_3");
                await this.allSfx[Settings.SfxStyle.SFX_3].play();
                await this.game.vo.playVO('CYB_Panel2_SoundEffect3On');
            }
        }));
        this.addChild( this.threeButton );

        this.updateToMatchSetting();
    }

    private setSfxType( value:Settings.SfxStyle )
    {
        this.oneButton.active = value === Settings.SfxStyle.SFX_1;
        this.twoButton.active = value === Settings.SfxStyle.SFX_2;
        this.threeButton.active = value === Settings.SfxStyle.SFX_3;

        if( value != this.settings.sfxType.value ) {
            this.settings.sfxType.value = value;
        }
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat([ this.oneButton, this.twoButton, this.threeButton ] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.setSfxType( this.settings.sfxType.value );
    }

    destroy()
    {
        for (const opt in this.allSfx)
        {
            this.allSfx[opt].destroy();
        }
        super.destroy();
    }
}